import posthog from 'posthog-js';

// PostHog analytics client.
//
// Configured via env vars (CRA inlines REACT_APP_* at build time):
//   REACT_APP_POSTHOG_KEY   - your PostHog Project API key (phc_...)
//   REACT_APP_POSTHOG_HOST  - ingestion host (US cloud: https://us.i.posthog.com)
//
// If the key is missing we skip init so the app still runs (analytics no-op).

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

export const posthogEnabled = Boolean(POSTHOG_KEY);

if (posthogEnabled) {
  posthog.init(POSTHOG_KEY as string, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',
    // Record activity for EVERY session, identified or not. With
    // 'identified_only' any failure to identify (a lost $identify, a login path
    // that never calls it, a user whose id is missing from the API response)
    // silently discards that user's events, person and session replay entirely.
    // 'always' creates a person profile up front; once identify() runs, PostHog
    // merges the anonymous person into the identified one, so nothing is lost.
    // Trade-off: anonymous visitors count toward billable persons.
    person_profiles: 'always',
    // Capture pageviews (incl. SPA route changes) and engagement automatically.
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    // Session replay (must ALSO be enabled in PostHog project settings).
    // Inputs are masked so passwords / sensitive fields never appear in replays.
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true
    },
    // Error Tracking. Without this, a crash produces no event at all — and
    // console.error is replaced with a no-op in production (see App.tsx), so
    // console_errors is left off: nothing would ever reach the wrapper.
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false
    }
  });
} else {
  // eslint-disable-next-line no-console
  console.warn(
    'PostHog disabled: set REACT_APP_POSTHOG_KEY in .env to enable analytics.'
  );
}

export default posthog;
